import { useLanguage } from "@/i18n/LanguageContext";
import { Reveal } from "@/components/Reveal";

export const IntroBlock = () => {
  const { t } = useLanguage();
  const b = t.introBlock;

  return (
    <section className="relative py-24 md:py-32 bg-[#01154F]">
      <div className="container-page">
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-16 items-start">
          <div className="lg:col-span-5">
            <Reveal>
              <span className="overline text-[#CEA26B]">{b.overline}</span>
              <h2 className="mt-4 font-display font-bold tracking-tight text-white text-3xl sm:text-4xl lg:text-[2.75rem] leading-[1.1]">
                {b.title}
              </h2>
            </Reveal>
          </div>
          <div className="lg:col-span-7 space-y-6 lg:pt-2">
            {b.paragraphs.map((p, i) => (
              <Reveal key={i} delay={0.08 * i}>
                <p className="text-base md:text-lg text-slate-300 leading-relaxed">{p}</p>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
